import ApiService from "@/common/api.service";

export const OnlineStatusService = {
    async getOnlineStatus(query) {
        const res = await ApiService.get(`/dashboard/online-status${query}`);
        return res.data;
    },
};
